import { UIModule } from "./ui-module.model";

export interface MobileAuthenticateData {
  application?: string;
  uiModule?: UIModule;
  mode?: string;
  sessionId?: string;
  firstName?: string;
  lastName?: string;
  personalCode: string;
  number: string;
  challengeID?: string;
  status?: MobileAuthenticationStatus;
  hashBase64?: string;
}

export enum MobileAuthenticationStatus {
  USER_AUTHENTICATED = "USER_AUTHENTICATED",
  NOT_VALID = "NOT_VALID",
  OUTSTANDING_TRANSACTION = "OUTSTANDING_TRANSACTION",
  EXPIRED_TRANSACTION = "EXPIRED_TRANSACTION",
  MID_NOT_READY = "MID_NOT_READY",
  USER_CANCEL = "USER_CANCEL",
  PHONE_ABSENT = "PHONE_ABSENT",
  SENDING_ERROR = "SENDING_ERROR",
  SIM_ERROR = "SIM_ERROR",
  INTERNAL_ERROR = "INTERNAL_ERROR",
  SERVER_MAINTENANCE = "SERVER_MAINTENANCE",
  USER_NOT_FOUND = "USER_NOT_FOUND",
  DELIVERY_ERROR = "DELIVERY_ERROR",
  NOT_MID_CLIENT = "NOT_MID_CLIENT",
  NOT_CLIENT_REVOKED = "NOT_CLIENT_REVOKED",
  SIM_CONF_ERROR = "SIM_CONF_ERROR",
  //following codes are additional codes used by the application
  CREDENTIALS = "CREDENTIALS",
  CHALLENGE = "CHALLENGE",
  OTHER = "OTHER",
}
